/* eslint-disable quote-props */
/**
 * 共通定数
 */
const ColorConstants = {
  ASSET_CODE: {
    '180': '#57B8D9',
    '050': '#FA9B3C',
    '040': '#AEDE49',
    '060': '#914DBB',
    '030': '#FFBCB0',
    '020': '#AFADD3',
    '070': '#506BB7',
    '100': '#E5413C',
    '090': '#36397B',
    '150': '#E075B2',
    '999': '#D1D1D1',
    '190': '#9B9169',
    '160': '#E075B2',
    '200': '#E075B2'
  },
  DEFAULT_COLOR: '#D1D1D1',
  INVEST_PRODUCT_CODE: {
    '010': '#57B8D9',
    '110': '#57B8D9',
    '080': '#57B8D9',
    '120': '#57B8D9',
    '130': '#57B8D9',
    '050': '#FA9B3C',
    '040': '#AEDE49',
    '060': '#CAA9DE',
    '030': '#FFBCB0',
    '020': '#AFADD3',
    '070': '#506BB7',
    '100': '#E5413C',
    '090': '#36397B',
    '150': '#E075B2',
    '160': '#E075B2',
    '170': '#D1D1D1'
  }
}
Object.freeze(ColorConstants)
export default ColorConstants
